import { DocumentMeta } from '../hooks/useDocumentMeta';

export default function TermsConditions() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8" style={{ fontFamily: 'var(--font-secondary)' }}>
      <DocumentMeta title="Termeni și Condiții" />
      <h1 className="mb-6 text-3xl font-bold" style={{ color: 'var(--vivid-purple)', fontFamily: 'var(--font-primary)' }}>
        Termeni și Condiții
      </h1>
      <p className="mb-4 text-sm text-muted-foreground">Ultima actualizare: 20/03/2026 · Versiunea 1.0</p>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>1. Descrierea Platformei</h2>
        <p>
          Platforma „Calendar Activități pentru Alba Iulia — Capitala Tineretului din România 2026" este un serviciu de management
          al evenimentelor și activităților dedicate tinerilor, operat de <strong>Asociația Eu Sunt</strong>
          {' '}(CIF: 34347234, Calea Moților, nr. 24, Alba Iulia, jud. Alba).
        </p>
        <p className="mt-2">
          Platforma permite utilizatorilor să vizualizeze calendarul de activități, să se înscrie la
          evenimente și să își gestioneze participările.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>2. Crearea Contului</h2>
        <p className="mb-2">
          Pentru a te înscrie la activități, trebuie să îți creezi un cont. Poți face asta prin:
        </p>
        <ul className="list-inside list-disc space-y-1">
          <li>Autentificare cu Google</li>
          <li>Autentificare cu Facebook</li>
          <li>Link magic trimis pe email</li>
        </ul>
        <p className="mt-2">
          La crearea contului, ești de acord cu acești termeni și condiții, precum și cu
          politica de confidențialitate.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>3. Obligațiile Utilizatorului</h2>
        <ul className="list-inside list-disc space-y-1">
          <li>Să furnizeze date reale și corecte la înregistrare</li>
          <li>Să nu folosească platforma în scopuri ilegale sau abuzive</li>
          <li>Să respecte regulile specifice fiecărei activități</li>
          <li>Să anuleze înscrierea dacă nu mai poate participa, pentru a elibera locul altor participanți</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>4. Înscrierea la Activități</h2>
        <p className="mb-2">
          Înscrierea la activități este gratuită și se face prin intermediul platformei. Unele activități
          pot avea:
        </p>
        <ul className="list-inside list-disc space-y-1">
          <li>Limită de participanți</li>
          <li>Restricții de vârstă (minim/maxim)</li>
          <li>Termen limită de înscriere</li>
          <li>Cerințe suplimentare pentru minori</li>
        </ul>
        <p className="mt-2">
          Organizatorul își rezervă dreptul de a anula sau modifica o activitate, caz în care
          participanții înscriși vor fi notificați.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>5. Partajarea Datelor la Înregistrare</h2>
        <p className="mb-2">
          La înscrierea la o activitate organizată de un partener, datele tale (nume, prenume, email,
          telefon și vârstă) sunt partajate cu organizatorii respectivi. La momentul înscrierii:
        </p>
        <ul className="list-inside list-disc space-y-1">
          <li>Ești informat despre partenerii cu care vor fi partajate datele</li>
          <li>Trebuie să consimți explicit la partajare</li>
          <li>Poți refuza partajarea — în acest caz nu te poți înscrie la activitate</li>
        </ul>
        <p className="mt-2">
          Organizatorii parteneri sunt legați prin Acorduri de Prelucrare a Datelor (DPA) cu
          operatorul platformei și au obligația de a prelucra datele exclusiv în scopul activității.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>6. Limitarea Răspunderii</h2>
        <p>
          Platforma este furnizată „așa cum este". Asociația Eu Sunt depune eforturi pentru a asigura
          disponibilitatea și corectitudinea informațiilor, dar nu garantează funcționarea neîntreruptă
          a serviciului. Nu suntem răspunzători pentru:
        </p>
        <ul className="mt-2 list-inside list-disc space-y-1">
          <li>Întreruperi temporare ale serviciului</li>
          <li>Pierderea datelor din cauza unor evenimente în afara controlului nostru</li>
          <li>Conținutul furnizat de organizatorii de activități parteneri</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>7. Proprietatea Intelectuală</h2>
        <p>
          Conținutul platformei (design, texte, logo-uri, imagini) este protejat de drepturile de
          proprietate intelectuală și aparține Asociației Eu Sunt sau partenerilor săi. Utilizarea
          neautorizată este interzisă.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>8. Ștergerea Contului</h2>
        <p>
          Poți șterge contul în orice moment din secțiunea „Contul Meu". La ștergere, datele personale
          vor fi anonimizate, iar înscriierile la activitățile viitoare vor fi anulate automat.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>9. Modificarea Termenilor</h2>
        <p>
          Ne rezervăm dreptul de a modifica acești termeni. Modificările vor fi publicate pe această
          pagină, cu data ultimei actualizări. Continuarea utilizării platformei după publicarea
          modificărilor constituie acceptarea noilor termeni.
        </p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>10. Contact</h2>
        <p>
          Pentru orice întrebări legate de acești termeni, ne poți contacta la:<br />
          <a href="mailto:contact.ctro@albaiulia2026.ro" className="text-[var(--vivid-purple)] underline">contact.ctro@albaiulia2026.ro</a>
        </p>
      </section>
    </div>
  );
}
